/**
 * @generated SignedSource<<a47086d500411c09491f4b7a6e5514b3>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type SubmitAddressChallengeResponseError = 'ADDRESS_NOT_FOUND' | 'IDENTITY_NOT_FOUND' | '%future added value';
export type SubmitAddressChallengeInput = {
  identityId: string;
  locality: string;
  streetAddress: string;
  subdivision: string;
  zip: string;
};
export type AddressChallengePageMutation$variables = {
  q: SubmitAddressChallengeInput;
};
export type AddressChallengePageMutation$data = {
  readonly submitAddressChallenge: {
    readonly data: {
      readonly success: boolean;
    } | null;
    readonly errors: ReadonlyArray<SubmitAddressChallengeResponseError>;
  };
};
export type AddressChallengePageMutation = {
  response: AddressChallengePageMutation$data;
  variables: AddressChallengePageMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'q',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'q',
            variableName: 'q',
          },
        ],
        concreteType: 'SubmitAddressChallengeResponseValidation',
        kind: 'LinkedField',
        name: 'submitAddressChallenge',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'SubmitAddressChallengeResponse',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'success',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errors',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'AddressChallengePageMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'AddressChallengePageMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '15072fa94d4062acf6acf2564b30b06d',
      id: null,
      metadata: {},
      name: 'AddressChallengePageMutation',
      operationKind: 'mutation',
      text: 'mutation AddressChallengePageMutation(\n  $q: SubmitAddressChallengeInput!\n) {\n  submitAddressChallenge(q: $q) {\n    data {\n      success\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'cbabb7e4865f5d05041178ffca3b8c5e';

export default node;
